import { daysYear, number_format } from "../../../../config/Helpers";
export const production_chart = (xAxis, budget, reach, current_year_values, last_year_value, years, format) => {
    const option = {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'cross',
                crossStyle: {
                    color: '#999'
                }
            },
            formatter : function(params){
                const sign = format === "room_night" ? '' : '$';
                const decimals = format === "adr" ? 2 : 0;
                const current_year = sign + number_format(params[0].value,decimals);
                const last_year = sign + number_format(params[1].value, decimals);
                const budget = sign + number_format(params[2].value, decimals);
                const reach = sign + number_format(params[3].value, 2);
                return "<div style='text-align : left;'>" + 
                    "<span style='display: inline-block; width : 10px; height : 10px; background : #ff7d4d; border-radius : 2px;'></span> Production " + years[0] + ": " + current_year + "<br />" + 
                    "<span style='display: inline-block; width : 10px; height : 10px; background : #fec400; border-radius : 2px;'></span> Production " + years[1] + ": "+ last_year + "<br />" + 
                    "<span style='display: inline-block; width : 10px; height : 10px; background : #ff4558; border-radius : 2px;'></span> Budget: " + budget + "<br />" +
                    "<span style='display: inline-block; width : 10px; height : 10px; background : #15d39a; border-radius : 2px;'></span> Reach: " + reach + "%<br />" +
                "</div>";
            }
        },
        legend: {
            data:["Production " + years[0], "Production " + years[1], "Budget"],
            orient: "vertical",
            right: "15px",
            top:   "25px",
            width: "80px",
        },
        grid: {
            right: "160px",
            top:   "35px",
            bottom : "35px",
            height : "220px"
        },
        xAxis: [
            {
                type: 'category',
                data: xAxis,
                axisPointer: {
                    type: 'shadow'
                }
            }
        ],
        yAxis: [
            {
                type: 'value',
                axisLabel : {
                    formatter : function(value, index){
                        const sign = format === "room_night" ? '' : '$';
                        return sign + number_format(value)
                    }
                },
            },
            {
                name: "Reach",
                type: 'value',
                show: false,
                axisLabel : {
                    formatter : function(value, index){
                        return number_format(value) + '%'
                    }
                }
            }
        ],
        series: [
            {
                name: "Production " + years[0],
                type: 'bar',
                data: current_year_values,
                color: "#ff7d4d",
                show : false
            },
            {
                name: "Production " + years[1],
                type: 'bar',
                data: last_year_value,
                color: "#fec400"
            },
            {
                name: 'Budget',
                type: 'line',
                data:budget,
                color: "#ff4558",
                lineStyle : {
                    width: 3,
                },
                symbolSize : 10
            },
            {
                name: 'Reach',
                type: 'line',
                data:reach,
                color: "#15d39a",
                lineStyle : {
                    width: 0,
                },
                symbolSize : 0
            }
        ]
    };   

    return option;
}

export const room_types_chart = (hotel_series, property_legend) => {

    var data = hotel_series;

    let option = {
        grid:{
            top: 25
        },
        series: {
            type: 'sunburst',
            nodeClick : false,
            highlightPolicy: 'ancestor',
            data: data,
            radius: [0, '95%'],
            sort: null,
            levels: [{}, {
                r0: '5%',
                r: '65%',
                itemStyle: {
                    borderWidth: 1,
                },
                label: {
                    rotate: 'tangential',
                }
            }, {
                r0: '65%',
                r: '85%',
                label: {
                    align: 'right',
                    width: "100px",
                    show: false
                }
            }]
        }
    };
    

    return option;
}

export const adr_chart = (series, format, max_days, min_interval, max_interval, max_min_reserve) => {

    const format_value = format === "room_night" ? '{value}' : '${value}';
    const option = {
        xAxis: {
            min: (parseInt(min_interval) - 1),
            max: max_interval,
            type: "category",
            splitLine: {
                show: true,
                interval : function(d){
                    if(Object.keys(max_days).length){
                        if(parseInt(d) === 0 ){
                            if(parseInt(d) === max_days["ENE"]){
                                return "ENE";
                            }
                        }else{
                            if(parseInt(d) === max_days["ENE"]){
                                return "ENE";
                            }else if(parseInt(d) === max_days["FEB"]){
                                return "FEB";
                            }else if(parseInt(d) === max_days["MAR"]){
                                return "MAR";
                            }else if(parseInt(d) === max_days["ABR"]){
                                return "ABR";
                            }else if(parseInt(d) === max_days["MAY"]){
                                return "MAY";
                            }else if(parseInt(d) === max_days["JUN"]){
                                return "JUN";
                            }else if(parseInt(d) === max_days["JUL"]){
                                return "JUL";
                            }else if(parseInt(d) === max_days["AGO"]){
                                return "AGO";
                            }else if(parseInt(d) === max_days["SEP"]){
                                return "SEP";
                            }else if(parseInt(d) === max_days["OCT"]){
                                return "OCT";
                            }else if(parseInt(d) === max_days["NOV"]){
                                return "NOV";
                            }else if(parseInt(d) === max_days["DIC"]){
                                return "DIC";
                            }
                        }
                    }
                }
            },
            data : daysYear(min_interval, max_interval),
            lineStyle : {
                color : "transparent"
            },
            axisTick: {
                show : false,
                
            },
            axisLabel: {
                rotate: 60,
                fontSize : 11,
                // force to display all labels
                interval : 0,
                formatter: function(d) {
                    if(Object.keys(max_days).length > 0){
                        if(parseInt(d) === 0 ){
                            if(parseInt(d) === max_days["ENE"]){
                                return "ENE";
                            }
                        }else{
                            if(parseInt(d) === max_days["ENE"]){
                                return "ENE";
                            }else if(parseInt(d) === max_days["FEB"]){
                                return "FEB";
                            }else if(parseInt(d) === max_days["MAR"]){
                                return "MAR";
                            }else if(parseInt(d) === max_days["ABR"]){
                                return "ABR";
                            }else if(parseInt(d) === max_days["MAY"]){
                                return "MAY";
                            }else if(parseInt(d) === max_days["JUN"]){
                                return "JUN";
                            }else if(parseInt(d) === max_days["JUL"]){
                                return "JUL";
                            }else if(parseInt(d) === max_days["AGO"]){
                                return "AGO";
                            }else if(parseInt(d) === max_days["SEP"]){
                                return "SEP";
                            }else if(parseInt(d) === max_days["OCT"]){
                                return "OCT";
                            }else if(parseInt(d) === max_days["NOV"]){
                                return "NOV";
                            }else if(parseInt(d) === max_days["DIC"]){
                                return "DIC";
                            }
                        }
                    }
                }
            }
        },
        yAxis: {
            axisLine: {
                show: false
            },
            type : "value",
            axisLabel : {
                formatter : function(value, index){
                    return number_format(value, 2)
                }
            },
            splitLine: {
                show: true,
                interval : 1
            }
        },
        grid: {
            right: "25px",
            left: "65px",
            top:   "35px",
            bottom : "45px",
        },
        series: [{
            type: 'effectScatter',
            symbolSize: 10,
            data: max_min_reserve
        }, {
            type: 'scatter',
            data: series,
            symbolSize: 6,
            color: "#000",
        }]
    };   

    return option;
}


export const topProducer = (data, index, data_agency) => {
    var data_agencies = data_agency.seriesData;
    if(index >= 0){
        if (typeof data.seriesData != 'undefined'){
            data_agencies = data.seriesData[index].agencies;
        }
    }else{
        data_agencies = data_agency.seriesData;
    }
    let option = {
        title : {
            show: false
        },
        grid:{
            width: "100%"
        },
        tooltip : {
            show : true,
            formatter : function(params){
                const occupied =  number_format(params.value,0);
                return "<div class='title-pie'>"+ params.name +"</div> <span class='nights-pie'>" + occupied + " PAX</span> <span class='percent-pie'>" + params.percent + "%</span>";
            },
            //formatter: "<div class='title-pie'>"+ params.name +"</div> <span class='nights-pie'>" + occupied + " R/N</span> <span class='percent-pie'>" + params.percent + "%</span>",
            backgroundColor: '#eee',
            borderColor: '#aaa',
            borderWidth: 1,
            borderRadius: 4
        },
        legend: {
            data:data.legendData,
            orient: "vertical",
            left: "15px",
            top:   "25px",
            width: "80px",
        },
        series : [
            {
                name:'Segment',
                type: 'pie',
                id: 'segments',
                title: 'Segments',
                radius: ['15%', '35%'],
                center: ['55%', '25%'],
                data: data.seriesData,
                selectedMode: 'single',
                itemStyle: {
                    emphasis: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                },
                avoidLabelOverlap: true,
                legendHoverLink : true,
                label: {
                    normal: {
                        show: true,
                        textStyle:{
                            fontSize: '11',
                        },
                        //formatter: '{b}: {c} R/N',
                        formatter : function(params){
                            const occupied =  number_format(params.value,0);
                            return params.name + ": " + occupied + " PAX";
                        },
                        position: 'outer'
                    },
                    emphasis: {
                        show: true,
                        textStyle: {
                            fontWeight: 'bold'
                        }
                    }
                },
            },{
                name:'Agency',
                type: 'pie',
                id: 'agencies',
                radius: ['08%', '25%'],
                center: ['55%', '75%'],
                data: data_agencies,
                itemStyle: {
                    emphasis: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                },
                avoidLabelOverlap: true,
                legendHoverLink : true,
                label: {
                    normal: {
                        show: true,
                        textStyle:{
                            fontSize: '10',
                        },
                        formatter : function(params){
                            const occupied =  number_format(params.value,0);
                            return params.name + ": " + occupied + " PAX";
                        },
                        position: 'outer',
                        padding : 3
                    },
                    emphasis: {
                        show: true,
                        textStyle: {
                            fontWeight: 'bold'
                        }
                    }
                },
            }
        ]
    };
    

    return option;
}



// WEBPACK FOOTER //
// ./src/Frontend/modules/marketing/reservations/widgets/Charts.js